import { Alert } from "antd";
import { Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "store";
import { noticeActions } from "store/notice/notice";
import { noticeSelector } from "store/notice/noticeSelector";
import styled from "styled-components";

const NoticeItem = ({ item }: any) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const id = setTimeout(() => dispatch(noticeActions.remove(item.key)), item.timeout);

    return () => clearTimeout(id);
  }, [item.key]);

  return <Alert type="success" onClose={() => dispatch(noticeActions.remove(item.key))} {...item} />;
};

export const Notice = () => {
  const items = useSelector(noticeSelector);

  return (
    <Container>
      {items.map((item) => {
        return (
          <Fragment key={item.key}>
            <NoticeItem item={item} />
          </Fragment>
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  z-index: 9999;
  bottom: 20px;
  left: 50%;
  min-width: 400px;
  max-width: calc(100vw - 300px);
  width: max-content;
  transform: translateX(-50%);

  & > * {
    margin-top: 5px;
  }
`;
